const $ = require('jquery');
const forEach = require('lodash.foreach');

// Find any and all images that have the .open-modal added to them.
var $modals = $('.open-modal');

// set an initial counter.
var current = 1;

// Loop through each item in the set.
$modals.each(function() {
  // add the needed data-popup-open attributes to them.
  $(this).attr('data-popup-open', 'image' + current);

  // create the modals and append them to the bottom of the body element.
  $('body').append('' +
    '<div class="popup" data-popup="image' + current + '">' +
    '<div class="popup-inner natural-width">' +
    '<img src="' + $(this).attr('src') + '" alt="JP Pest Services" />' +
    '<span class="popup-close" data-popup-close="image' + current + '" href="#"><span class="icon-close"></span></span>' +
    '</div>' +
    '</div>');

  // increment the counter.
  current++;
});





// Open the Modal Popup Windows.
$('[data-popup-open]').on('click', function(e) {

  // Prevent the default behavior on the link.
  e.preventDefault();

  // Grab the value of the data-popup-open attribute for this specific modal window.
  var $targetedModal = $(this).attr('data-popup-open');

  // Open the specific modal.
  $('[data-popup="' + $targetedModal + '"]').fadeIn(350);

});


// Close the Modal Popup Windows.
$('[data-popup-close]').on('click', function(e) {

  // Prevent the default behavior on the link.
  e.preventDefault();

  // Grab the value of the data-popup-close attribute for this specific modal window.
  var $targetedModal = $(this).attr('data-popup-close');

  // Close the specific modal.
  $('[data-popup="' + $targetedModal + '"]').fadeOut(350);

});


// Allow closing of the Modal Popup Windows by clicking outside of them.
// Grab the .popup dimmed out area of the screen.
$('.popup').click(function(event) {

  // If the target of the user's click is anywhere on the modal that is NOT the dimmed out area, then do nothing with the function.
  if (event.target !== this) {
    return;
  }

  // Otherwise, fade out the open modal window.
  $(this).fadeOut(350);

});
